import { render, staticRenderFns } from "./UpdateAppPersonalInfo.vue?vue&type=template&id=0a5721ce&scoped=true&"
import script from "./UpdateAppPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateAppPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAppPersonalInfo.vue?vue&type=style&index=0&id=0a5721ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5721ce",
  null
  
)

export default component.exports